<script>
import { BModal } from 'bootstrap-vue';
import { Alert } from '../../services/alert';
import showUpgradePlanAlert from '../../mixins/showUpgradePlanAlert';

export default {
  components: {
    BModal,
  },

  mixins: [showUpgradePlanAlert],

  data () {
    return {
      plans: [],
      selectedPlan: '',
      isUpdatingPlan: false,
      isFetchingPlans: false,
    };
  },

  computed: {
    fixedSelectOptionText () {
      if (this.isFetchingPlans) {
        return 'Carregando...'
      }

      return 'Para planos acima de 100.000 consulte o suporte';
    }
  },

  async mounted () {
    Bus.$on('openUpgradePlanModal', async () => {
      this.openModal();

      this.getPlans();
    });
  },

  methods: {
    openModal () {
      this.$refs['upgrade-tenant-plan-modal'].show();
    },

    hideModal () {
      this.$refs['upgrade-tenant-plan-modal'].hide();
    },

    getPlans () {
      this.isFetchingPlans = true;

      this.$http.get('/billing/details')
        .then(({ body }) => {
          const plans = body.plans;

          const nextPlan = plans[0];

          if (nextPlan && nextPlan.provider_id) {
            this.selectedPlan = nextPlan.provider_id;
          }

          this.plans = plans;
        })
        .catch(() => {
          Alert.error('Ocorreu um erro ao buscar os planos disponíveis');

          this.hideModal();
        })
        .finally(() => {
          this.isFetchingPlans = false;
        })
    },

    upgradePlan () {
      if (!this.selectedPlan) {
        Alert.error('Um plano não foi selecionado');
        return;
      }

      this.isUpdatingPlan = true;

      this.$http.put('/billing/plan', { plan: this.selectedPlan })
        .then(({ body }) => {
          this.hideModal();

          this.showConfirmationAlert(body);
        })
        .catch(() => {
          this.hideModal();

          Alert.error('Erro ao fazer upgrade de plano');
        })
        .finally(() => {
          this.isUpdatingPlan = false;
        });
    },
  },
};
</script>

<template>
  <BModal
    id="upgrade-tenant-plan-modal"
    ref="upgrade-tenant-plan-modal"
    hide-footer="hide-footer"
    hide-header="hide-header"
    centered
  >
    <button
      class="close-button"
      type="button"
      aria-label="Fechar"
      v-on:click="hideModal"
    >
      <span aria-hidden="true">×</span>
    </button>

    <h2 class="upgrade-plan-modal-title">
      Upgrade de plano
    </h2>

    <form
      class="upgrade-plan-form"
      @submit.prevent="upgradePlan"
    >
      <div>
        <label for="plan-select">Selecione o plano</label>
        <select
          id="plan-select"
          name="plan-select"
          v-model="selectedPlan"
        >
          <option
            v-for="plan in plans"
            :value="plan.provider_id"
          >
            {{ plan.name }}
          </option>
          <option
            value=""
            disabled
          >
            {{ fixedSelectOptionText }}
          </option>
        </select>
      </div>

      <button
        id="upgrade-plan-modal-button"
        class="salesflow-btn salesflow-btn-secondary mb-3"
        :disabled="isUpdatingPlan"
      >
        Fazer upgrade
      </button>

      <button
        class="cancel-button"
        type="button"
        v-on:click="hideModal"
      >
        Cancelar
      </button>

    </form>

  </BModal>
</template>

<style lang="scss">
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  #upgrade-tenant-plan-modal {
    .modal-dialog {
      max-width: 540px;
      height: 100%;
      border-radius: 16px;
      overflow: hidden;
      margin: 0px auto;

      .modal-content {
        border-radius: 16px;
        overflow: hidden;
      }

      .modal-body {
        padding: 3rem 5rem 1.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        background-color: $salesflow-bg-content;

        .upgrade-plan-modal-title {
          @include salesflow-title($font-weight: 500);
          margin-bottom: 0px;
        }

        .upgrade-plan-form {
          display: flex;
          flex-direction: column;
          max-width: 100%;

          div {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;

            label {
              @include salesflow-text($font-weight: 500);
              margin-bottom: 0px;
            }

            #plan-select {
              min-width: 378px;
              padding: 18px 24px 18px 12px;
              max-width: 100%;
              background-color: white;
              border: 1px solid $salesflow-outline-gray-medium;
              border-radius: 8px;
              outline: 0px;
              color: $salesflow-font-gray;
              font-weight: 500;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          #upgrade-plan-modal-button {
            max-width: fit-content;
            margin: 40px auto 0px;

            &:focus {
              outline: 0px;
            }

            &:disabled {
              opacity: 0.7;
              cursor: not-allowed;
            }
          }

          .cancel-button {
            padding: 0px;
            margin: 0px;
            border: 0px;
            outline: 0px;
            background-color: transparent;
            @include salesflow-text($color: $salesflow-font-gray, $font-weight: 600);
            text-decoration: underline;

            &:hover {
              color: $salesflow-purple-dark;
            }
          }
        }

        .close-button {
          position: absolute;
          top: 16px;
          right: 18px;
          background-color: transparent;
          border: 0px;
          outline: 0px;
          padding: 0px;
          margin: 0px;

          font-size: 2rem;
          line-height: 1.5rem;
          color: $salesflow-font-gray;
          background-color: transparent;
        }
      }
    }
  }

  .container-upgrade-plan-swal {
    .swal2-modal {
      width: 332px;
      border-radius: 16px;
      padding-bottom: 48px;
      background-color: $salesflow-bg-content;

      .swal2-icon {
        margin-top: 48px;
      }

      h2 {
        @include salesflow-subtitle($font-weight: 700);
        margin-bottom: 0px;
      }

      .info-container {
        width: 236px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 1rem 0.5rem;
        margin: auto;
        border: 1px solid $salesflow-outline-gray-medium;
        border-radius: 16px;
        background-color: white;

        .info-title {
          @include salesflow-text($color: $salesflow-font-gray);
        }

        .info-value {
          @include salesflow-text($font-weight: 600);
        }
      }

      .swal2-actions {
        margin-top: 24px;
      }
    }
  }
</style>
